import React from 'react';
import { Checkbox } from 'module-tsl-ui-elements';
import { getFromContext } from '../../AlertFiltersContext';

export const AlertFrequency = () => {
  const { state: { id, frequency, prefix }, dispatch } = getFromContext();

  const hasFrequency = (value) => frequency === value;

  const onChange = ({target: { value }})=> {
    dispatch({type: 'frequency', value});
  };

  return (
    <div className={`${prefix}__frequency`}>
      <div>Email notifications</div>
      <Checkbox
        caption='Daily'
        checked={hasFrequency('daily')}
        value='daily'
        onChange={onChange}
        isRadio
        showLabel
      />

      <Checkbox
        caption='Weekly'
        checked={hasFrequency('weekly')}
        value='weekly'
        onChange={onChange}
        isRadio
        showLabel
      />

      { Boolean(id) &&
        <Checkbox
          caption='Pause'
          checked={hasFrequency('disabled')}
          value='disabled'
          onChange={onChange}
          isRadio
          showLabel
        />
      }
    </div>
  );
};
